import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CommitStatus from '../../../components/CommitStatus';
export const PrItemStatus = (props) => {
    const { repositoryActive, pullRequest, gha, onRegisterRepo, isRegisterWebhookBtnDisabled, link, loading } = props;
    const { t } = useTranslation();
    if (!repositoryActive && onRegisterRepo) {
        return _jsx("div", { className: 'pr-list__col pr-list__col--vertical-center pr-list__link col-3 col-md-2 d-none d-md-flex', children: _jsx("button", { className: 'btn btn-link ml-auto mr-auto', onClick: onRegisterRepo, disabled: isRegisterWebhookBtnDisabled, "data-testid": 'button-register-webhook', children: t(gha ? 'installApp' : 'registerWebhook') }) });
    }
    return _jsx(Link, { to: link, className: 'pr-list__col pr-list__col--vertical-center pr-list__link col-3 col-md-2 d-none d-md-flex', "data-testid": 'link-pr-detail', children: _jsx(CommitStatus, { entity: pullRequest, isPullRequest: true, loading: loading }) });
};
